import { object, string } from "yup";

export const DEFAULT_VALUES = {
  preservedReason: "",
  reason: "",
};

export const VALIDATION_SCHEMA = object().shape({
  preservedReason: string().required("Harus diisi"),
  reason: string().when("preservedReason", {
    is: "Others",
    then: (schema) => schema.required("Harus diisi"),
    otherwise: (schema) => schema.notRequired(),
  }),
});
